var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"diy-topbar__modal"},[_vm._t("header",function(){return [_c('div',_vm._g({staticClass:"diy-topbar__modal-title"},_vm.$listeners),[_c('AppIcon',{attrs:{"icon":"fal fa-chevron-left"}}),_c('AppHeading',{attrs:{"tag":"h3","text":_vm.name}})],1)]}),_c('div',{staticClass:"diy-topbar__modal-content"},[_vm._t("content")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }